"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonFieldLogic = void 0;
var button_fieldtype_1 = require("./button.fieldtype");
Object.defineProperty(exports, "ButtonFieldLogic", { enumerable: true, get: function () { return button_fieldtype_1.ButtonFieldLogic; } });
